<template>
  <div class="v2-view-recap-container">
    <template v-if="isBusy || isBusyResend">
      <div class="table-loader">
        <Preloader />
      </div>
    </template>
    <template v-else-if="currentStep === 5">
      <div class="v2-success-view">
        <div class="success-header">
          <div class="success-icon-badge">
            <font-awesome-icon icon="check" />
          </div>
          <h1>Merci pour votre souscription !</h1>
          <p>Votre contrat de garantie auto a été validé et enregistré.</p>
        </div>

        <div class="success-main-content">
          <div class="document-download-card">
            <div class="doc-info">
              <div class="doc-icon">
                <font-awesome-icon icon="file-pdf" />
              </div>
              <div class="doc-details">
                <h3>Certificat de Garantie</h3>
                <span>Format PDF • Prêt à imprimer</span>
              </div>
            </div>
            <button type="button" class="btn-download-pdf" @click="showPdf">
              <font-awesome-icon icon="eye" />
              Aperçu
            </button>
          </div>

          <div class="success-actions">
            <button type="button" class="btn-link-action" @click="restartFresh">
              <font-awesome-icon icon="plus-circle" />
              Souscrire à une autre garantie
            </button>
            <router-link to="/devis" class="btn-link-action secondary">
              <font-awesome-icon icon="th-list" />
              Voir mes devis
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Header Section -->
      <header class="v2-view-header">
        <div class="header-left">
          <!-- <router-link to="/devis" class="v2-back-link" v-if="showRetourButton">
            <font-awesome-icon icon="arrow-circle-left" />
            Retour
          </router-link> -->
          <h1>Devis en ligne</h1>
        </div>
        <div class="header-right" v-if="!currentStep">
          <router-link :to="'/garantie-camping-car-v2/' + $route.params.id" class="v2-modify-btn">
            <font-awesome-icon icon="pencil-alt" />
            Modifier
          </router-link>
        </div>
      </header>

      <div class="v2-view-grid">
        <!-- Main Column -->
        <main class="v2-main-col">

          <!-- Warnings -->
          <div class="alert alert-warning mb-2"
            v-if="guaranty.details && guaranty.details.registration && numberOfDuplicates > 0">
            <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
            Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro d’immatriculation.
          </div>

          <div class="v2-view-accordion-stack">
            <!-- Client Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': ownerExpanded }"
              v-if="guaranty && guaranty.client">
              <header class="accordion-header" @click="ownerExpanded = !ownerExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="user-circle" />
                  <h2>Vos coordonnées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="ownerExpanded">
                <div class="v2-title-header-row pl-4">
                  <div class="v2-view-section-title text-uppercase">
                    Informations sur le propriétaire du Camping-Car :
                  </div>
                </div>
                <div class="card-body grid-adaptive">
                  <div class="info-item" v-if="+guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                    <label>Civilité :</label>
                    <span class="info-val">{{ parseCivility(guaranty.client.civility) }}</span>
                  </div>
                  <div class="info-item" v-else>
                    <label>Société :</label>
                    <span class="info-val">{{ guaranty.client.name_of_signatory }}</span>
                  </div>

                  <div class="info-item">
                    <label>
                      {{ +guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Nom :' : 'Nom du signataire : ' }}
                    </label>
                    <span class="info-val">{{ guaranty.client.last_name || "" }}</span>
                  </div>

                  <div class="info-item" v-if="guaranty.client.first_name">
                    <label>
                      {{
                        +guaranty.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Prénom :' : 'Prénom du signataire: '
                      }}
                    </label>
                    <span class="info-val">{{ guaranty.client.first_name || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Email :</label>
                    <span class="info-val">{{ guaranty.client.email || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Téléphone :</label>
                    <span class="info-val">{{ guaranty.client.tel || "" }}</span>
                  </div>

                  <div class="info-item" v-if="guaranty.client.fax">
                    <label>Fax :</label>
                    <span class="info-val">{{ guaranty.client.fax || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Adresse :</label>
                    <span class="info-val text-capitalize">{{ guaranty.client.address || "" }}, {{ guaranty.client.zip
                      ||
                      "" }} {{ guaranty.client.city || "" }}</span>
                  </div>

                  <div class="info-item"
                    v-if="guaranty.client && guaranty.client.birthday && guaranty.client.birthday != '1900-01-01 00:00:00'">
                    <label>Date de naissance :</label>
                    <span class="info-val">{{ parseBirthDate(guaranty) }}</span>
                  </div>


                </div>
              </div>
            </section>

            <!-- Vehicle Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': vehicleExpanded }"
              v-if="guaranty.details">
              <header class="accordion-header" @click="vehicleExpanded = !vehicleExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="bus" />
                  <h2>Votre Camping-car</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="vehicleExpanded">
                <div class="v2-title-header-row pl-4">
                  <div class="v2-view-section-title text-uppercase">
                    Informations sur le Camping-car à assurer :
                  </div>
                </div>
                <div class="card-body grid-adaptive">
                  <div class="info-item">
                    <label>Immatriculation :</label>
                    <span class="info-val plate-style">{{ guaranty.details.registration || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Voiture neuve :</label>
                    <span class="info-val">{{ getIsNew() }}</span>
                  </div>

                  <div class="info-item">
                    <label>Type de garantie :</label>
                    <span class="info-val">{{ showGuaranty }}</span>
                  </div>

                  <div class="info-item">
                    <label>Durée :</label>
                    <span class="info-val">{{ showDuration }}</span>
                  </div>

                  <div class="info-item">
                    <label>Marque du porteur :</label>
                    <span class="info-val">{{ guaranty.details.marque_porteur ||
                      guaranty.details_camping_car.marque_porteur || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Modèle du porteur :</label>
                    <span class="info-val">{{ guaranty.details.modele_porteur ||
                      guaranty.details_camping_car.modele_porteur || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Puissance fiscale :</label>
                    <span class="info-val">{{ guaranty.details.fiscal_power || "" }} CV</span>
                  </div>

                  <div class="info-item">
                    <label>Kilométrage :</label>
                    <span class="info-val">{{ guaranty.details.km_real || "" }} KM</span>
                  </div>

                  <div class="info-item">
                    <label>Date de 1ère mise en circulation :</label>
                    <span class="info-val">{{ parseCirculationDate(guaranty.details) ||
                      parseCirculationDate(guaranty.details_camping_car) || "" }}</span>
                  </div>

                  <div class="info-item">
                    <label>Date d'effet :</label>
                    <span class="info-val">{{ parseEffectiveDate(guaranty.details) }}</span>
                  </div>

                  <div class="info-item text-uppercase">
                    <label>Assistance souhaitée :</label>
                    <span class="info-val">{{ showAssistance }}</span>
                  </div>

                  <div class="info-item" v-if="guaranty.finance == 1">
                    <label>Organisme de financement :</label>
                    <span class="info-val">{{ guaranty.finance_name }}</span>
                  </div>

                  <div class="info-item">
                    <label>Numéro de série :</label>
                    <span class="info-val">{{ guaranty.details.serial_number || "" }}</span>
                  </div>

                  <!-- Optional Technical Specs -->
                  <div class="info-item" v-if="guaranty.details.cardans">
                    <label>Cardans, embrayage, freinage :</label>
                    <span class="info-val">{{ guaranty.details.cardans }}</span>
                  </div>
                  <div class="info-item" v-if="guaranty.details.pumps">
                    <label>Pompes, radiateur, alternateur, démarreur :</label>
                    <span class="info-val">{{ guaranty.details.pumps }}</span>
                  </div>
                  <div class="info-item" v-if="guaranty.details.injections">
                    <label>Turbo, pompe à injection :</label>
                    <span class="info-val">{{ guaranty.details.injections }}</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- Info & Disclaimer Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': infoExpanded }">
              <header class="accordion-header" @click="infoExpanded = !infoExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="info-circle" />
                  <h2>Durée et Prise d'effet</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="infoExpanded">
                <div class="card-body">
                  <div class="v2-warranty-info-text">
                    <div class="v2-selected-plan-banner" v-if="guaranty.details">
                      Vous avez choisi la garantie <strong>{{ showGuaranty }}</strong>
                      pour une durée de <strong>{{ showDuration }}</strong>
                    </div>
                    <p v-if="mechanicCode != '705223'">
                      Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie par
                      <strong>Dynassurances</strong>,
                      la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                      particuli&egrave;res du contrat
                      et prendra fin automatiquement &agrave; 24 heures jour pour jour selon les dates indiqu&eacute;es
                      sur le certificat de garantie.
                    </p>
                    <p v-else>
                      Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie,
                      la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                      particuli&egrave;res du contrat
                      et prendra fin automatiquement &agrave; 24 heures jour pour jour selon les dates indiqu&eacute;es
                      sur le certificat de garantie.
                    </p>

                    <p class="font-weight-bold mt-3 text-uppercase rem-12">Véhicules couverts :</p>
                    <p class="rem-14">Tout véhicule camping car de moins de 5 tonnes, et moins de 120.000 kilomètres à
                      la
                      souscription, sauf véhicule de location.</p>

                    <p class="font-weight-bold mt-4">Cependant la garantie prendra fin de plein droit avant son terme :
                    </p>
                    <ul class="v2-feature-list">
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de destruction du v&eacute;hicule, quelle qu'en soit la cause, par
                          r&eacute;siliation,</span>
                      </li>
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de d&eacute;ch&eacute;ance du b&eacute;n&eacute;ficiaire de la garantie pour non
                          respect des prescriptions du constructeur sur l'usage pour lequel le v&eacute;hicule est
                          con&ccedil;u.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <!-- Coverage & Rules Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': guaranteesExpanded }">
              <header class="accordion-header" @click="guaranteesExpanded = !guaranteesExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="shield-alt" />
                  <h2>Garanties accordées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="guaranteesExpanded">
                <div class="card-body">
                  <h2 class="font-weight-bold">
                    POUR LE PORTEUR
                  </h2>
                  <div v-if="guaranty.details && guaranty.details.garantie == 1">
                    <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
                      <div class="description">
                        <p>
                          <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs,
                          tiges de culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement
                          en cas de rupture), paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes
                          et guides, pompe à huile, culasse et joint de culasse et turbo.
                        </p>
                        <p><strong>Dans la Boite de vitesses</strong> :</p>
                        <p>
                          <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs,
                          synchros, roulements.
                        </p>
                        <p>
                          <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de
                          couple, vannes et soupapes, régulateur, plateau.
                        </p>
                        <p>
                          <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière,
                          différentiels, pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des
                          cardans.
                        </p>
                        <p>
                          <strong>Pour la cellule</strong> : Pompe à eau, carte électronique chauffe-eau, agrégat
                          réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte électronique du , à
                          l’exception des faisceaux. Les problèmes d’étanchéité (couverture des dommages résultant d’une
                          modification anormale de la cellule, à l’exception des baies et des ouvrants, si la
                          périodicité des contrôles annuels prévus par le constructeur a été respectée).
                        </p>
                        <p>
                          <strong>Les pièces de la cellule </strong> : pompe à eau, Carte électronique chauffe-eau,
                          agrégat réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte
                          électronique du réfrigérateur, à l’exception des faisceaux. Les problèmes d’étanchéité
                          (couverture des dommages résultant d’une modification anormale de la cellule, à l’exception
                          des baies et des ouvrants, si la périodicité des contrôles annuels prévus par le constructeur
                          a été respectée).
                        </p>
                        <p>
                          <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5
                          tonnes et moins de 120 000 kilomètres à la souscription.
                        </p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="garantie-view__body__block--content">
                        <h4 class="ql-align-center">
                          <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                        </h4>
                        <div class="description">
                          <div class="list mt-3">
                            <ul class="list__ul">
                              <li>
                                <b>Dans le Moteur :</b>
                                <div>
                                  Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de
                                  culbuteurs, poussoirs, chaines de distribution, courroie de distribution
                                  (uniquement en cas de rupture), paliers de vilebrequin, vilebrequin, pistons
                                  et axes, segments, soupapes et guides, pompe à huile, culasse et joint de
                                  culasse et turbo.
                                </div>
                              </li>
                              <li>
                                <b>Dans la Boite de vitesses :</b>
                                <div>
                                  Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs,
                                  synchros, roulements.
                                </div>
                                <div>
                                  Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de
                                  couple, vannes et soupapes, régulateur, plateau.
                                </div>
                              </li>
                              <li>
                                <b>Dans le dispositif de transmission :</b>
                                <div>
                                  Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A
                                  l’exclusion des arbres de roues, de transmission et des cardans.
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="guaranty.details && guaranty.details.garantie == 2">
                    <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
                      <div class="description">
                        <p>
                          <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs,
                          tiges de culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement
                          en cas de rupture), paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes
                          et guides, pompe à huile, culasse et joint de culasse et turbo.
                        </p>
                        <p><strong>Dans la Boite de vitesses</strong> :</p>
                        <p>
                          <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs,
                          synchros, roulements.
                        </p>
                        <p>
                          <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de
                          couple, vannes et soupapes, régulateur, plateau.
                        </p>
                        <p>
                          <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière,
                          différentiels, pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des
                          cardans.
                        </p>
                        <p>
                          <strong>Dans le dispositif de refroidissement</strong> : Radiateur d'eau, pompe à eau,
                          ventilateur.
                        </p>
                        <p>
                          <strong>Dans le système électrique</strong> : Alternateur, démarreur, serrure de porte,
                          moteurs et mécanismes de lèves vitres, moteurs d'essuie glace et de toit ouvrant, compresseur
                          et condenseur de climatisation à l’exception de la recharge de gaz.
                        </p>
                        <p>
                          <strong>Dans le système de direction</strong> : Crémaillère ou boîtier, pompe d'assistance, à
                          l'exception de la colonne, des rotules et biellettes.
                        </p>
                        <p>
                          <strong>Dans le système de freinage</strong> : Maître cylindre, servofrein, répartiteur, pompe
                          à vide, bloc hydraulique ABS.
                        </p>
                        <p>
                          <strong>Dans le système d’alimentation</strong> : Allumeur, module électronique d'allumage,
                          bobine, pompe à injection, boîtier électronique d'injection, pompes d'alimentation en
                          carburant, boitier papillon d’injection, débitmètre, vanne EGR. A l'exception des injecteurs.
                        </p>
                        <p>
                          <strong>Dans le dispositif d’embrayage</strong> : Mécanisme, fourchette, émetteur, récepteur.
                        </p>
                        <p>
                          <strong>Pour la cellule</strong> : Pompe à eau, carte électronique chauffe-eau, agrégat
                          réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte électronique du , à
                          l’exception des faisceaux. Les problèmes d’étanchéité (couverture des dommages résultant d’une
                          modification anormale de la cellule, à l’exception des baies et des ouvrants, si la
                          périodicité des contrôles annuels prévus par le constructeur a été respectée).
                        </p>
                        <p>
                          <strong>Les pièces de la cellule </strong> : pompe à eau, Carte électronique chauffe-eau,
                          agrégat réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte
                          électronique du réfrigérateur, à l’exception des faisceaux. Les problèmes d’étanchéité
                          (couverture des dommages résultant d’une modification anormale de la cellule, à l’exception
                          des baies et des ouvrants, si la périodicité des contrôles annuels prévus par le constructeur
                          a été respectée).
                        </p>
                        <p>
                          <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5
                          tonnes et moins de 120 000 kilomètres à la souscription.
                        </p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="garantie-view__body__block--content">
                        <h4 class="ql-align-center">
                          <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                        </h4>
                        <div class="description">
                          <div class="list mt-3">
                            <ul class="list__ul">
                              <li>
                                <b>Dans le Moteur :</b>
                                <div>
                                  Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de culbuteurs,
                                  poussoirs, chaines de distribution, courroie de distribution (uniquement en cas de
                                  rupture), paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes et
                                  guides, pompe à huile, culasse et joint de culasse et turbo.
                                </div>
                              </li>
                              <li>
                                <b>Dans la Boite de vitesses :</b>
                                <div>
                                  Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                                  roulements.
                                </div>
                                <div>
                                  Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de couple,
                                  vannes et soupapes, régulateur, plateau.
                                </div>
                              </li>
                              <li>
                                <b>Dans le dispositif de transmission :</b>
                                <div>
                                  Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A l’exclusion
                                  des arbres de roues, de transmission et des cardans.
                                </div>
                              </li>
                              <li>
                                <b>Dans le dispositif de refroidissement :</b>
                                <div>Radiateur d'eau, pompe à eau, ventilateur.</div>
                              </li>
                              <li>
                                <b>Dans le système électrique :</b>
                                <div>
                                  Alternateur, démarreur, serrure de porte, moteurs et mécanismes de lèves vitres,
                                  moteurs d'essuie glace et de toit ouvrant, compresseur et condenseur de climatisation
                                  à l’exception de la recharge de gaz.
                                </div>
                              </li>
                              <li>
                                <b>Dans le système de direction :</b>
                                <div>
                                  Crémaillère ou boîtier, pompe d'assistance, à l'exception de la colonne, des rotules
                                  et biellettes.
                                </div>
                              </li>
                              <li>
                                <b>Dans le système de freinage :</b>
                                <div>Maître cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique ABS.</div>
                              </li>
                              <li>
                                <b>Dans le système d’alimentation :</b>
                                <div>Allumeur, module électronique d'allumage, bobine, pompe à injection, boîtier
                                  électronique d'injection, pompes d'alimentation en carburant, boitier papillon
                                  d’injection, débitmètre, vanne EGR. A l'exception des injecteurs.</div>
                              </li>
                              <li>
                                <b>Dans le dispositif d’embrayage :</b>
                                <div>Mécanisme, fourchette, émetteur, récepteur.</div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="guaranty.details && guaranty.details.garantie == 3">
                    <div class="garantie-view__body__block--content" v-if="!is_LeMondeCampingCar">
                      <div class="description">
                        <p>
                          <strong>Dans le Moteur</strong> : Arbre à cames, coussinets de bielles, bielles, culbuteurs,
                          tiges de culbuteurs, poussoirs, chaines de distribution, courroie de distribution (uniquement
                          en cas de rupture), paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes
                          et guides, pompe à huile, culasse et joint de culasse et turbo.
                        </p>
                        <p><strong>Dans la Boite de vitesses</strong> :</p>
                        <p>
                          <strong>Manuelle</strong> : Toutes les défaillances internes : Pignons, arbres, sélecteurs,
                          synchros, roulements.
                        </p>
                        <p>
                          <strong>Automatique</strong> : Pignons, pompe à huile, bagues et arbres, convertisseur de
                          couple, vannes et soupapes, régulateur, plateau.
                        </p>
                        <p>
                          <strong>Dans le dispositif de transmission</strong> : Boîte de transfert, pont arrière,
                          différentiels, pignons et couronnes. A l’exclusion des arbres de roues, de transmission et des
                          cardans.
                        </p>
                        <p>
                          <strong>Dans le dispositif de refroidissement</strong> : Radiateur d'eau, pompe à eau,
                          ventilateur.
                        </p>
                        <p>
                          <strong>Dans le système électrique</strong> : Alternateur, démarreur, serrure de porte,
                          moteurs et mécanismes de lèves vitres, moteurs d'essuie glace et de toit ouvrant, compresseur
                          et condenseur de climatisation à l’exception de la recharge de gaz.
                        </p>
                        <p>
                          <strong>Dans le système de direction</strong> : Crémaillère ou boîtier, pompe d'assistance, à
                          l'exception de la colonne, des rotules et biellettes.
                        </p>
                        <p>
                          <strong>Dans le système de freinage</strong> : Maître cylindre, servofrein, répartiteur, pompe
                          à vide, bloc hydraulique ABS.
                        </p>
                        <p>
                          <strong>Dans le système d’alimentation</strong> : Allumeur, module électronique d'allumage,
                          bobine, pompe à injection, boîtier électronique d'injection, pompes d'alimentation en
                          carburant, boitier papillon d’injection, débitmètre, vanne EGR et les injecteurs.
                        </p>
                        <p>
                          <strong>Dans le dispositif d’embrayage</strong> : Mécanisme, fourchette, émetteur, récepteur
                          et volant moteur.
                        </p>
                        <p>
                          <strong>Les pièces de la cellule</strong> : Pompe à eau, Carte électronique chauffe-eau,
                          agrégat réfrigérateur, transformateur et chargeur électrique, pulseur d’air, carte
                          électronique du réfrigérateur, à l’exception des faisceaux, moteur de lit électrique,
                          mécanisme électrique du marchepied, mécanisme de volet-store, moteur d’antenne électrique. Les
                          problèmes d’étanchéité (couverture des dommages résultant d’une modification anormale de la
                          cellule, à l’exception des baies et des ouvrants, si la périodicité des contrôles annuels
                          prévus par le constructeur a été respectée).
                        </p>
                        <p>
                          <strong>Important </strong> : Cette garantie est réservée aux camping-cars de moins de 5
                          tonnes, de moins de 10 ans et moins de 120 000 kilomètres à la souscription.
                        </p>
                      </div>
                    </div>
                    <div v-else>
                      <div class="garantie-view__body__block--content">
                        <h4 class="ql-align-center">
                          <strong>LES PIÈCES GARANTIES (PORTEUR)</strong>
                        </h4>
                        <div class="description">
                          <div class="list mt-3">
                            <ul class="list__ul">
                              <li>
                                <b>Dans le Moteur :</b>
                                <div>
                                  Arbre à cames, coussinets de bielles, bielles, culbuteurs, tiges de culbuteurs,
                                  poussoirs, chaines de distribution, courroie de distribution (uniquement en cas de
                                  rupture), paliers de vilebrequin, vilebrequin, pistons et axes, segments, soupapes et
                                  guides, pompe à huile, culasse et joint de culasse et turbo.
                                </div>
                              </li>
                              <li>
                                <b>Dans la Boite de vitesses :</b>
                                <div>
                                  Manuelle : Toutes les défaillances internes : Pignons, arbres, sélecteurs, synchros,
                                  roulements.
                                </div>
                                <div>
                                  Automatique : Pignons, pompe à huile, bagues et arbres, convertisseur de couple,
                                  vannes et soupapes, régulateur, plateau.
                                </div>
                              </li>
                              <li>
                                <b>Dans le dispositif de transmission :</b>
                                <div>
                                  Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A l’exclusion
                                  des arbres de roues, de transmission et des cardans.
                                </div>
                              </li>
                              <li>
                                <b>Dans le dispositif de refroidissement :</b>
                                <div>Radiateur d'eau, pompe à eau, ventilateur.</div>
                              </li>
                              <li>
                                <b>Dans le système électrique :</b>
                                <div>
                                  Alternateur, démarreur, serrure de porte, moteurs et mécanismes de lèves vitres,
                                  moteurs d'essuie glace et de toit ouvrant, compresseur et condenseur de climatisation
                                  à l’exception de la recharge de gaz.
                                </div>
                              </li>
                              <li>
                                <b>Dans le système de direction :</b>
                                <div>
                                  Crémaillère ou boîtier, pompe d'assistance, à l'exception de la colonne, des rotules
                                  et biellettes.
                                </div>
                              </li>
                              <li>
                                <b>Dans le système de freinage :</b>
                                <div>Maître cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique ABS.</div>
                              </li>
                              <li>
                                <b>Dans le système d’alimentation :</b>
                                <div>Allumeur, module électronique d'allumage, bobine, pompe à injection, boîtier
                                  électronique d'injection, pompes d'alimentation en carburant, boitier papillon
                                  d’injection, débitmètre, vanne EGR. A l'exception des injecteurs.</div>
                              </li>
                              <li>
                                <b>Dans le dispositif d’embrayage :</b>
                                <div>Mécanisme, fourchette, émetteur, récepteur.</div>
                              </li>
                              <li>
                                <b>Les pièces de la cellule :</b>
                                <div>Pompe à eau, Carte électronique chauffe-eau, agrégat réfrigérateur, transformateur
                                  et chargeur électrique, pulseur d’air, carte électronique du réfrigérateur, à
                                  l’exception des faisceaux, moteur de lit électrique, mécanisme électrique du
                                  marchepied, mécanisme de volet-store, moteur d’antenne électrique. Les problèmes
                                  d’étanchéité (couverture des dommages résultant d’une modification anormale de la
                                  cellule, à l’exception des baies et des ouvrants, si la périodicité des contrôles
                                  annuels prévus par le constructeur a été respectée).</div>
                              </li>
                              <li>
                                <b>Pour la cellule :</b>
                                <div>
                                  Pompe à eau, carte électronique chauffe-eau, agrégat réfrigérateur, transformateur et
                                  chargeur électrique, pulseur d’air, carte électronique du , à l’exception des
                                  faisceaux. Les problèmes d’étanchéité (couverture des dommages résultant d’une
                                  modification anormale de la cellule, à l’exception des baies et des ouvrants, si la
                                  périodicité des contrôles annuels prévus par le constructeur a été respectée).
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="garantie-view__body__block--content">
                      <div class="description">

                        <div class="label mt-5">
                          <div class="label--bold">
                            TABLEAU DE REMBOURSEMENT
                          </div>
                        </div>

                        <table style="width: 100%; border-collapse: collapse; color: black;" class="mt-5">
                          <thead style="display: table-header-group;">
                            <tr style="display: table-row;">
                              <th style="border: 1px solid #000; padding: 12px; text-align: left; font-weight: bold;">
                                ÂGE DU CAMPING-CAR AU MOMENT DU SINISTRE
                              </th>
                              <th style="border: 1px solid #000; padding: 12px; text-align: left; font-weight: bold;">
                                PRISE EN CHARGE DE LA FACTURE
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style="display: table-row;">
                              <td style="border: 1px solid #000; padding: 12px;">&lt; 4 ANS</td>
                              <td style="border: 1px solid #000; padding: 12px;">100%</td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid #000; padding: 12px;">&lt; 6 ANS</td>
                              <td style="border: 1px solid #000; padding: 12px;">80%</td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid #000; padding: 12px;">&lt; 8 ANS</td>
                              <td style="border: 1px solid #000; padding: 12px;">60%</td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid #000; padding: 12px;">&lt; 10 ANS</td>
                              <td style="border: 1px solid #000; padding: 12px;">50%</td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid #000; padding: 12px;">&gt; 10 ANS</td>
                              <td style="border: 1px solid #000; padding: 12px;">40%</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                  <template>
                    <div class="garantie-view__body__block--content">
                      <div class="description">

                        <div class="label mt-5">
                          <div class="label--bold">
                            FRANCHISE
                          </div>
                        </div>
                        <div>
                          Une franchise de 10% avec un minimum de 76 € sera appliquée sur le montant de tout sinistre
                          pris en charge pour les véhicules de moins de 3.5 T.
                          <br>
                          Une franchise de 20% avec un minimum de 150 € sera appliquée sur le montant de tout sinistre
                          pris en charge pour les véhicules de moins de 3.5 T jusqu’à 5 T.
                        </div>

                        <div class="label mt-5">
                          <div class="label--bold">
                            PLAFOND DE REMBOURSEMENT
                          </div>
                        </div>

                        <div v-if="guaranty.details && guaranty.details.garantie == 3">
                          Le montant total des réparations réglée pendant la durée de la présente garantie ne pourra
                          dépasser, ni le montant de l’achat du Camping-car, ni sa valeur vénale, ni le plafond de
                          remboursement par avarie de 4 000 € TTC sur le véhicule porteur et 2 000 € TTC sur la Cellule
                          du Camping-Car.
                        </div>
                        <div v-else>
                          Le montant total des réparations réglée pendant la durée de la présente garantie ne pourra
                          dépasser, ni le montant de l’achat du Camping-car, ni sa valeur vénale, ni le plafond de
                          remboursement par avarie de 2 300 € TTC sur le véhicule porteur et 1 000 € TTC sur la Cellule
                          du Camping-Car.
                        </div>

                      </div>
                    </div>
                  </template>

                </div>
              </div>
            </section>
          </div>
        </main>

        <!-- Sidebar -->
        <aside class="v2-sticky-sidebar">
          <div class="v2-price-card">
            <div class="v2-price-header">
              <div class="v2-price-label text-uppercase">Prime totale T.T.C. (&euro;) *</div>
              <div class="v2-price-amount" v-if="getPrice && checkValidPTC">{{ getPrice }}</div>
              <div class="alert alert-danger p-2 rem-12" v-else>
                Les critères du véhicule ne permettent pas de souscrire à la garantie choisie.
              </div>
              <p class="price-note">* Frais de dossier et taxe attentats inclus.</p>
            </div>

            <!-- <div class="v2-price-details" v-if="guaranty && guaranty.assistance_price > 0">
              <div class="detail-row">
                <span>Dont pack assistance (1 an)</span>
                <strong>{{ roundEURWithoutSymbol(guaranty.assistance_price).replace(".", ",") }} &euro;</strong>
              </div>
            </div> -->

            <div class="v2-actions-stack">
              <!-- Subscribe Button -->
              <button type="button" class="btn-primary-outline" v-if="getGarantiePrice && checkValidPTC"
                @click.prevent="changeStep">
                <font-awesome-icon icon="rocket" />
                Souscrire à la garantie
              </button>

              <!-- Email Button -->
              <!-- <button type="button" class="btn-success-outline" @click.prevent="resendEmail">
                <font-awesome-icon icon="envelope" />
                Envoyer le devis par e-mail
              </button> -->

              <!-- Save Button -->
              <button type="button" class="v2-btn-block outline"
                @click.prevent="mechanicCode != '705223' ? getFrontPdf() : getFrontPdfWL()">
                <font-awesome-icon icon="file-download" />
                Sauvegarder sur mon ordinateur
              </button>


              <!-- Print Button -->
              <button type="button" class="v2-btn-block outline"
                @click.prevent="mechanicCode != '705223' ? getFrontPdf(true) : getFrontPdfWL(true)">
                <font-awesome-icon icon="print" />
                Imprimer le détail de la garantie
              </button>

              <hr class="my-2">

              <button type="button" class="btn-secondary-outline" @click="closeQuote()">Fermer</button>
            </div>

            <div class="v2-price-footer">
              <div class="v2-contact-info">
                <span>CONTACTER OU SOUSCRIRE :</span>
                <p class="mb-0 fs-11"><a href="tel:+33148895757">01 48 89 57 57</a></p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </template>
  </div>
</template>

<script>
import Preloader from "@/components/Preloader";
import insuranceMethods from "@/mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "@/constants/client";
import pdfPreviewMixin from '@/mixins/pdfPreviewMixin';

export default {
  name: "GarantieCampingCarView",
  components: {
    Preloader,
  },
  mixins: [insuranceMethods, pdfPreviewMixin],
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    insuranceData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      guaranty: {},
      isBusy: false,
      isBusyResend: false,
      family_status_list: ["Célibataire", "Marié(e)"],
      professions_list: [
        "",
        "Artisant/commerçant",
        "Exploitant agricole",
        "Profession libérale",
        "Chef d'entreprise",
        "Salarié",
        "Fonctionnaire",
        "VRP",
        "Etudiant",
        "Sans profession",
        "Retraité",
      ],
      guaranty_list: ["", "Réseau", "Maxi Réseau", "Maxi Plus"],
      duration_list: ["", "6 Mois", "12 Mois", "24 Mois", "36 Mois", "48 Mois"],
      assistance_list: ["Pack Assistance", "Sans pack assistance"],
      showRetourButton: false,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
      ownerExpanded: true,
      vehicleExpanded: true,
      infoExpanded: false,
      guaranteesExpanded: false,
    };
  },
  created() {
    if (this.insuranceData) {
      this.getGuarantyInfo(this.insuranceData.id);
    } else if (this.$route.params.id) {
      this.getGuarantyInfo(this.$route.params.id);
    }
  },
  computed: {
    getDownloadLinkConfirmationPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.guaranty.id
        );

      return "";
    },

    showFamilyStatus() {
      return this.family_status_list[this.guaranty.client.family]
        ? this.family_status_list[this.guaranty.client.family]
        : "";
    },
    showProfession() {
      return this.professions_list[this.guaranty.client.profession]
        ? this.professions_list[this.guaranty.client.profession]
        : "";
    },
    // Details
    showGuaranty() {
      if (this.guaranty.mechanic_id == 4885) {
        if (typeof this.guaranty.details.garantie === 'string') {
          let garantie = parseInt(this.guaranty.details.garantie);
          if (garantie > 0) {
            return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
          }
        } else if (typeof this.guaranty.details.garantie === 'number') {
          let garantie = this.guaranty.details.garantie;
          if (garantie > 0) {
            return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
          }
        }
        let garantie = parseInt(this.guaranty.guarantee) - 1;
        return this.guaranty_list[garantie] ? this.guaranty_list[garantie] : "";
      }
      return this.guaranty_list[this.guaranty.details.garantie ? this.guaranty.details.garantie : this.guaranty.guarantee]
        ? this.guaranty_list[this.guaranty.details.garantie ? this.guaranty.details.garantie : this.guaranty.guarantee]
        : "";
    },
    showDuration() {
      if (this.guaranty && this.guaranty.details && this.guaranty.details.duration) {
        return this.duration_list[this.guaranty.details.duration]
          ? this.duration_list[this.guaranty.details.duration]
          : "";
      } else if (this.guaranty && this.guaranty.details_camping_car && this.guaranty.details_camping_car.duration) {
        return this.duration_list[parseInt(this.guaranty.details_camping_car.duration)]
          ? this.duration_list[parseInt(this.guaranty.details_camping_car.duration)]
          : "";
      }
    },
    showAssistance() {
      return this.assistance_list[this.guaranty.details.assistance]
        ? this.assistance_list[this.guaranty.details.assistance]
        : "";
    },
    getDownloadLink() {
      if (this.guaranty.id) {
        if (this.$store.getters.isLeMondeCampingCar) {
          // alert('LMCC');
          return this.getApiAuthUrl("garantie/generate-lmcc-pdf/" + this.guaranty.id);
        }
        else
          return this.getApiAuthUrl("garantie/generate-pdf/" + this.guaranty.id);
      }

      return "";
    },
    getDownloadLinkWL() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.guaranty.id
        );

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.guaranty.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.guaranty.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.guaranty.id
        );

      return "";
    },
    getPrice() {
      return this.guaranty.price
        ? this.roundEURWithoutSymbol(this.guaranty.price).replace(".", ",") +
        " €"
        : "";
    },
    getGarantiePrice() {
      return this.guaranty.price && +this.guaranty.price > 0;
    },
    checkValidPTC() {
      if (this.guaranty.details && this.guaranty.details.ptc && this.guaranty.details.ptc == 3) {
        return false;
      }
      return true;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
    is_LeMondeCampingCar() {
      if (this.$store.getters.isLeMondeCampingCar)
        return true;
      else
        return false;
    },
  },
  methods: {
    parseCivility(civility) {
      switch (+civility) {
        case 0:
          return "Monsieur";
        case 1:
          return "Mademoiselle";
        case 2:
          return "Madame";
        case 3:
          return "Société";
        case 4:
          return "Monsieur et Madame";
        default:
          return "";
      }
    },
    showPdf() {
      this.show_pdf(this.guaranty.id);
      // this.restartFresh();
    },
    restartFresh() {
      window.location.href = "/garantie-camping-car-v2";
    },
    changeStep(step = 5) {
      const serialNumber = (this.guaranty.details && this.guaranty.details.serial_number) || 
                           (this.guaranty.details_camping_car && this.guaranty.details_camping_car.serial_number);
      if (!serialNumber) {
        this.showErrorNotificationText(
            "Le numéro de série (VIN) du véhicule est manquant.<br>" +
            "Veuillez retourner à l'étape 1, ouvrir le popup <strong>Modifier le véhicule</strong> " +
            "et saisir le Numéro de série (VIN) avant de souscrire à la garantie.",
            null
        );
        return;
      }
      this.mechanicCode != '705223' ? this.getPDF() : this.getPDFWL()
    },
    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    parseCirculationDate(details) {
      if (!details) return "";

      if (details.date_circulation_formated) {
        return this.moment(details.date_circulation_formated).format("DD/MM/YYYY");
      }

      if (!details.day_circulation && !details.month_circulation && !details.year_circulation) return "";

      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date()).date(day).month(month).year(year);
      return date.format("DD/MM/YYYY");
    },
    parseSaleDate(quoteDatails) {
      if (quoteDatails.sale_date) {
        return this.moment(quoteDatails.sale_date).format("DD/MM/Y");
      }

      return "";
    },
    parseEffectiveDate(quoteDatails) {
      if (quoteDatails.effective_date) {
        return this.moment(quoteDatails.effective_date).format("DD/MM/Y");
      }

      return "";
    },
    parseDeliveryDate(quoteDatails) {
      if (quoteDatails.delivery_date) {
        return this.moment(quoteDatails.delivery_date).format("DD/MM/Y");
      }

      return "";
    },
    parseBirthDate(quoteDatails) {
      if (quoteDatails.client.birthday) {
        return this.moment(quoteDatails.client.birthday).format("DD/MM/Y");
      }

      return "";
    },
    getGuarantyInfo(id) {
      if (!id || id === 'undefined') {
        console.log('Aborting getGuarantyInfo: invalid or missing ID');
        return;
      }
      this.isBusy = true;
      let url = "garantie/" + id;
      this.apiGet(url)
        .then((response) => {
          this.guaranty = response.data.quote ? response.data.quote : {};
          this.numberOfDuplicates = response.data.duplicates;
          this.isBusy = false;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    printInsurance() {
      this.ownerExpanded = true;
      this.vehicleExpanded = true;
      this.infoExpanded = true;
      this.guaranteesExpanded = true;

      setTimeout(() => {
        window.print();
      }, 300); // allow UI to update
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = "garantie/resend-email/" + this.guaranty.id;

      this.apiPost(url, {})
        .then((response) => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
            this.$set(this.guaranty, "was_sent", response.data.quote.was_sent);
            this.changeStep(5);
          }
        })
        .catch((error) => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getPDF() {
      if (this.checkEffectiveDate(this.guaranty)) {
        this.isBusy = true;
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              fetch(this.getDownloadLink, {
                method: 'GET',
                credentials: 'include'
              })
                .then(() => {
                  console.log('PDF generation triggered');
                })
                .catch(err => {
                  console.error('Error triggering PDF', err);
                }).finally(() => {
                  this.isBusy = false;
                  this.$emit('change-step', 5);
                });
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getPDFWL() {
      if (this.checkEffectiveDate(this.guaranty)) {
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLinkWL) {
              fetch(this.getDownloadLinkWL, {
                method: 'GET',
                credentials: 'include'
              })
                .then(() => {
                  console.log('PDF generation triggered');
                })
                .catch(err => {
                  console.error('Error triggering PDF', err);
                });
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkConfirmationPdf) {
            window.location = this.getDownloadLinkConfirmationPdf;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorNotification(error);
        });
    },
    getFrontPdf(stream = false) {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdf) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdf + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdf);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getFrontPdfWL(stream = false) {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdfWL) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdfWL + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdfWL);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getIsNew() {
      if (typeof this.guaranty.details.is_new === 'number') {
        return (this.guaranty.details.is_new == 1) ? 'Oui' : 'Non';
      } else if (typeof this.guaranty.details.is_new === 'string') {
        if (this.guaranty.details.is_new == '1') return 'Oui';
        if (this.guaranty.details.is_new == '0') return 'Non';
        return this.guaranty.details.is_new;
      }
      return this.guaranty.details.is_new;
    },
    closeQuote() {
      if (this.showRetourButton) {
        this.$router.push("/devis");
      } else {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    if (this.insuranceData) {
      this.getGuarantyInfo(this.insuranceData.id);
    } else if (this.$route.params.id) {
      this.getGuarantyInfo(this.$route.params.id);
    }

    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Camping Car");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/garantie-camping-car-v2";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/camping-car/GarantieCampingCarView.vue